<template>
    <div class="mb-4 dm-previous-book mb-6">
        <div class="dm-book-fields mb-4">
            {{ translate("Title") }}
            <input
                type="text"
                class="form-control form-control-solid form-control-lg"
                :class="'dm-title-field-' + index"
                v-model="previous_book['title']"
                @change="$emit('booksUpdated')"
            />
            {{ translate("Publisher") }}
            <input
                type="text"
                class="form-control form-control-solid form-control-lg"
                :class="'dm-publisher-field-' + index"
                v-model="previous_book['publisher']"
                @change="$emit('booksUpdated')"
            />
            {{ translate("Year") }}
            <input
                type="number"
                min="1950"
                max="2030"
                class="form-control form-control-solid form-control-lg"
                :class="
                    ('dm-year-field-' + index, { 'border-danger': isWrongYear })
                "
                v-model="previous_book['year']"
                @change="checkYearValidAndEmit()"
            />
        </div>
        <div>
            <button
                class="btn btn-xs btn-icon btn-light-danger"
                @click="$emit('remove')"
            >
                <i class="icon-sm las la-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ["previous_book", "index"],
    data() {
        return {
            isWrongYear: false,
        };
    },

    methods: {
        checkYearValidAndEmit() {
            // Prevent years before 1950;
            if (this.previous_book["year"] < 1950)
                this.previous_book["year"] = 1950;

            // Prevent years larger than current
            let year = new Date().getFullYear();

            if (this.previous_book["year"] > year)
                this.previous_book["year"] = year;

            this.$emit("booksUpdated");

            this.isWrongYear = true;

            setTimeout(() => {
                this.isWrongYear = false;
            }, 2000);
        },
    },
};
</script>
